import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { infoModal } from 'vl-common/src/components/Modals';

export const useFileEncryptionHintModal = () => {
  const dispatch = useDispatch();

  return useCallback(async () => {
    try {
      const res = await dispatch(actions.getFilePasswordFormated());

      infoModal({
        title: res?.title || 'Error',
        content: res?.template_body ? (
          <div style={{ paddingTop: '16px' }} dangerouslySetInnerHTML={{ __html: res.template_body }} />
        ) : (
          'No encrypted file hint available'
        ),
        centered: true,
        zIndex: 9999
      });
    } catch (error) {
      console.error('Failed to fetch file password format:', error);
    }
  }, [dispatch]);
};
